import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
var isGroup = function isGroup(option) {
  return option && Array.isArray(option.options);
};
var menuRenderer = function menuRenderer(_ref) {
  var focusedOption = _ref.focusedOption,
    focusOption = _ref.focusOption,
    inputValue = _ref.inputValue,
    instancePrefix = _ref.instancePrefix,
    onFocus = _ref.onFocus,
    onOptionRef = _ref.onOptionRef,
    _onSelect = _ref.onSelect,
    optionClassName = _ref.optionClassName,
    optionComponent = _ref.optionComponent,
    optionGroupComponent = _ref.optionGroupComponent,
    optionRenderer = _ref.optionRenderer,
    options = _ref.options,
    removeValue = _ref.removeValue,
    selectValue = _ref.selectValue,
    valueArray = _ref.valueArray,
    valueKey = _ref.valueKey;
  var OptionGroup = optionGroupComponent;
  var Option = optionComponent;
  var renderLabel = optionRenderer;
  var selectedValues = valueArray ? valueArray.map(function (v) {
    return v.value;
  }) : [];
  var renderOptions = function renderOptions(optionsSubset) {
    return optionsSubset.map(function (option, i) {
      // const isSelected = valueArray && valueArray.indexOf(option) > -1;
      var isSelected = selectedValues.indexOf(option.value) >= 0;
      var isFocused = option === focusedOption;
      var optionClass = classNames(optionClassName, {
        'Select-option': true,
        'is-selected': isSelected,
        'is-focused': isFocused,
        'is-disabled': option.disabled
      });
      if (isGroup(option)) {
        var optionGroupClass = classNames({
          'Select-option-group': true
        });
        return /*#__PURE__*/React.createElement(OptionGroup, {
          className: optionGroupClass,
          key: "option-group-".concat(i),
          label: renderLabel(option),
          option: option,
          optionIndex: i
        }, renderOptions(option.options));
      } else {
        return /*#__PURE__*/React.createElement(Option, {
          className: optionClass,
          focusOption: focusOption,
          inputValue: inputValue,
          instancePrefix: instancePrefix,
          isDisabled: option.disabled,
          isFocused: isFocused,
          isSelected: isSelected,
          key: "option-".concat(i, "-").concat(option[valueKey]),
          onFocus: onFocus,
          onSelect: function onSelect(choice) {
            return _onSelect({
              label: choice.label,
              value: choice.value
            });
          },
          option: option,
          optionIndex: i,
          ref: function ref(_ref2) {
            onOptionRef(_ref2, isFocused);
          },
          removeValue: removeValue,
          selectValue: selectValue
        }, renderLabel(option, i));
      }
    });
  };
  return renderOptions(options);
};
menuRenderer.propTypes = {
  focusOption: PropTypes.func,
  focusedOption: PropTypes.object,
  inputValue: PropTypes.string,
  instancePrefix: PropTypes.string,
  onFocus: PropTypes.func,
  onOptionRef: PropTypes.func,
  onSelect: PropTypes.func,
  optionClassName: PropTypes.string,
  optionComponent: PropTypes.func,
  optionRenderer: PropTypes.func,
  options: PropTypes.array,
  removeValue: PropTypes.func,
  selectValue: PropTypes.func,
  valueArray: PropTypes.array,
  valueKey: PropTypes.string
};
export default menuRenderer;